define('views/content/filter',[
  "globals",
  "backbone"
], function (globals, Backbone) {
  "use strict";

  return Backbone.View.extend({
    events: {
      "click a[role = menuitem]": "click"
    },

    initialize: function () {
      _.bindAll(this, "click", "toggle");
      this.menuItems = this.$el.find("a[role=menuitem]");

      // TODO: read from toc model. Because toc model has not been initialized
      // yet, listen to changes in filter attribute
      var filter = globals.content.get("filter");
      var view = this;
      this.menuItems.each(function () {
        var m = $(this);
        _.each(filter, function (value, key) {
          if (!_.isUndefined(m.data(key)) && _.contains(value, m.data(key))) {
            view.toggle(m, true);
          }
        });
      });
    },

    click: function (event) {
      var el = $(event.currentTarget);
      if (el.is(".clear")) {
        var f = this.toggle;
        this.menuItems.each(function () { f($(this), false); });
      } else {
        this.toggle(el);
      }

      var active = this.menuItems.filter(".active");
      var filter = {};
      _.each(["series", "version"], function (f) {
        var v = active.filter("[data-" + f + "]").map(function () {
          return $(this).data(f);
        }).get();

        if (!_.isEmpty(v)) {
          filter[f] = v;
        }
      });
      globals.content.set("filter", filter);

      if (el.is(".clear")) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    },

    toggle: function (menuItem, active) {
      var a = !_.isUndefined(active) ? active : !menuItem.is(".active");

      if (a) {
        menuItem.addClass("active")
                .append("<i class='fa fa-check pull-right'></i>");
      } else {
        menuItem.removeClass("active").find("i").remove();
      }
      if (this.menuItems.is(".active")) {
        this.$el.find(".all").hide().end().find(".some").show();
      } else {
        this.$el.find(".all").show().end().find(".some").hide();
      }
    }
  });
});

